/* GLAMIEX theme scripts. No dependencies. Works alongside Horizon's own scripts. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) {
    return (r || document).querySelector(s);
  }
  function $$(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- money ---------- */
  function withDelimiters(cents, precision, thousands, decimal) {
    var n = (Number(cents) / 100).toFixed(precision);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  function formatMoney(cents) {
    var format = (window.GLX && window.GLX.moneyFormat) || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount':
          return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals':
          return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return withDelimiters(cents, 0, ' ', '.');
        case 'amount_with_space_separator':
          return withDelimiters(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return withDelimiters(cents, 2, ' ', '.');
        default:
          return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  /* small image from Shopify's CDN (product photos can be 2 MB originals) */
  function thumb(src, w) {
    if (!src) return '';
    try {
      var u = new URL(src, location.origin);
      u.searchParams.set('width', String(w));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(message, opts) {
    opts = opts || {};
    var old = $('.glx-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'glx-toast' + (opts.error ? ' glx-toast--error' : '');
    el.setAttribute('role', opts.error ? 'alert' : 'status');
    el.innerHTML = '<span>' + esc(message) + '</span>' + (opts.href ? '<a href="' + esc(opts.href) + '">' + esc(opts.label || 'View cart') + '</a>' : '');
    document.body.appendChild(el);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.remove();
    }, opts.error ? 6000 : 4500);
  }

  /* ---------- cart ---------- */
  function cartUrl() {
    return (window.GLX && window.GLX.cartUrl) || root + 'cart';
  }
  function addToCart(id, quantity) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
        return data;
      });
    });
  }
  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        $$('[data-glx-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('glx:cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function () {});
  }

  /* quick add on product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-glx-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    if (window.GLXCart && window.GLXCart.opening) window.GLXCart.opening();
    addToCart(btn.getAttribute('data-variant-id'), 1)
      .then(function () {
        btn.classList.add('is-done');
        setTimeout(function () {
          btn.classList.remove('is-done');
        }, 1500);
        return refreshCartCount();
      })
      .then(function (cart) {
        if (window.GLXCart) window.GLXCart.afterAdd(cart);
        else toast((btn.getAttribute('data-title') || 'Item') + ' added to your cart', { href: cartUrl(), label: 'View cart' });
      })
      .catch(function (err) {
        if (window.GLXCart && window.GLXCart.addFailed) window.GLXCart.addFailed();
        toast(err.message, { error: true });
      })
      .then(function () {
        btn.classList.remove('is-busy');
      });
  });

  /* ---------- wishlist (saved in this browser) ---------- */
  var WL_KEY = 'glx:wishlist';
  function wlRead() {
    try {
      var v = JSON.parse(localStorage.getItem(WL_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function wlWrite(list) {
    try {
      localStorage.setItem(WL_KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function wlSync() {
    var list = wlRead();
    $$('[data-glx-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-glx-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }
  function wlRender() {
    var box = $('[data-glx-wish-list]');
    if (!box) return;
    var list = wlRead();
    if (!list.length) {
      box.innerHTML = '<p class="glx-muted">Tap the heart on any product to save it here.</p>';
      return;
    }
    box.innerHTML = '<p class="glx-muted">Loading...</p>';
    Promise.all(
      list.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (items) {
      var html = '';
      var keep = [];
      items.forEach(function (p, i) {
        if (!p) return;
        keep.push(list[i]);
        var img = '';
        if (p.featured_image) {
          try {
            var u = new URL(p.featured_image, location.origin);
            u.searchParams.set('width', '160');
            img = u.toString();
          } catch (e) {
            img = p.featured_image;
          }
        }
        html +=
          '<div class="glx-wl-item">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '<span></span>') +
          '<div><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="glx-wl-item__price">' + esc(formatMoney(p.price)) + '</span></div>' +
          '<button type="button" data-glx-wl-remove="' + esc(list[i]) + '">Remove</button></div>';
      });
      if (keep.length !== list.length) wlWrite(keep);
      box.innerHTML = html || '<p class="glx-muted">Tap the heart on any product to save it here.</p>';
      wlSync();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-glx-wish]');
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-handle');
      var list = wlRead();
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1);
      else list.push(h);
      wlWrite(list);
      wlSync();
      return;
    }
    var rm = e.target.closest('[data-glx-wl-remove]');
    if (rm) {
      var handle = rm.getAttribute('data-glx-wl-remove');
      wlWrite(
        wlRead().filter(function (x) {
          return x !== handle;
        })
      );
      wlSync();
      wlRender();
    }
  });

  /* ---------- drawers ---------- */
  var openDrawer = null;
  var lastTrigger = null;
  function focusables(el) {
    return $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', el).filter(function (n) {
      return n.offsetParent !== null;
    });
  }
  function showDrawer(name, trigger, opts) {
    var d = $('[data-glx-drawer="' + name + '"]');
    if (!d) return;
    if (openDrawer) hideDrawer();
    d.hidden = false;
    openDrawer = d;
    lastTrigger = trigger || null;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.setAttribute('scroll-lock', '');
    if (name === 'wishlist') wlRender();
    if (name === 'cart' && window.GLXCart && !(opts && opts.skipRender)) window.GLXCart.render();
    var f = focusables(d.querySelector('.glx-drawer__panel'));
    if (f[0]) f[0].focus();
  }
  function hideDrawer() {
    if (!openDrawer) return;
    openDrawer.hidden = true;
    document.documentElement.removeAttribute('scroll-lock');
    $$('[data-glx-open]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    if (lastTrigger) lastTrigger.focus();
    openDrawer = null;
    lastTrigger = null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-glx-open]');
    if (t) {
      e.preventDefault();
      showDrawer(t.getAttribute('data-glx-open'), t);
      return;
    }
    if (e.target.closest('[data-glx-close]')) {
      e.preventDefault();
      hideDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openDrawer) hideDrawer();
      closeAllCats();
      closeSearch();
    }
    if (e.key === 'Tab' && openDrawer) {
      var f = focusables(openDrawer.querySelector('.glx-drawer__panel'));
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- all categories dropdown ---------- */
  function closeAllCats() {
    $$('[data-glx-toggle="allcats"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-glx-toggle="allcats"]');
    if (b) {
      var p = document.getElementById(b.getAttribute('aria-controls'));
      var open = b.getAttribute('aria-expanded') === 'true';
      closeAllCats();
      if (!open && p) {
        p.hidden = false;
        b.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.glx-allcats')) closeAllCats();
  });

  /* ---------- predictive search ---------- */
  var searchCtl;
  var searchCache = {};
  function closeSearch() {
    $$('[data-glx-search-results]').forEach(function (r) {
      r.hidden = true;
    });
  }
  function initSearch(form) {
    if (form.getAttribute('data-glx-init')) return;
    form.setAttribute('data-glx-init', '1');
    var input = $('.glx-search__input', form);
    var box = $('[data-glx-search-results]', form);
    var timer;
    var allUrl = function (q) { return root + 'search?type=product&q=' + encodeURIComponent(q); };
    function show(q, data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            box.innerHTML = '<p class="glx-search__msg">No products found for "' + esc(q) + '".</p>';
          } else {
            box.innerHTML =
              products
                .map(function (p) {
                  var img = thumb(p.featured_image && p.featured_image.url ? p.featured_image.url : p.image, 120);
                  var price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
                  return (
                    '<a class="glx-sres" href="' + esc(p.url) + '">' +
                    (img ? '<img class="glx-sres__img" src="' + esc(img) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="glx-sres__img"></span>') +
                    '<span><span class="glx-sres__title">' + esc(p.title) + '</span><span class="glx-sres__price">' + esc(price) + '</span></span></a>'
                  );
                })
                .join('') +
              '<a class="glx-sres__all" href="' + esc(allUrl(q)) + '">See all results</a>';
          }
          box.hidden = false;
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) {
        box.hidden = true;
        return;
      }
      var key = q.toLowerCase();
      if (searchCache[key]) {
        show(q, searchCache[key]);
        return;
      }
      if (searchCtl) searchCtl.abort();
      searchCtl = 'AbortController' in window ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' }, signal: searchCtl ? searchCtl.signal : undefined })
        .then(function (r) {
          if (!r.ok) throw new Error('search');
          return r.json();
        })
        .then(function (data) {
          searchCache[key] = data;
          if (input.value.trim().toLowerCase() === key) show(q, data);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          box.innerHTML = '<a class="glx-sres__all" href="' + esc(allUrl(q)) + '">Search for "' + esc(q) + '"</a>';
          box.hidden = false;
        });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length >= 2 && !searchCache[q.toLowerCase()]) {
        box.innerHTML = '<p class="glx-search__msg">Searching...</p>';
        box.hidden = false;
      }
      timer = setTimeout(run, 150);
    });
    input.addEventListener('focus', function () {
      if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false;
    });
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = $$('.glx-sres, .glx-sres__all', box);
      if (!items.length || box.hidden) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') i = i + 1 >= items.length ? 0 : i + 1;
      else i = i <= 0 ? -1 : i - 1;
      if (i === -1) input.focus();
      else items[i].focus();
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) box.hidden = true;
    });
  }

  /* ---------- announcement rotation ---------- */
  function initAnnounce(el) {
    if (el.getAttribute('data-glx-init')) return;
    el.setAttribute('data-glx-init', '1');
    var slides = $$('.glx-announce__slide', el);
    if (slides.length < 2) return;
    var i = 0;
    var timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
      });
    }
    var prev = $('[data-glx-announce-prev]', el);
    var next = $('[data-glx-announce-next]', el);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    if (el.getAttribute('data-autoplay') === 'true' && !reduceMotion) {
      var speed = parseInt(el.getAttribute('data-speed'), 10) || 5000;
      timer = setInterval(function () { show(i + 1); }, speed);
      el.addEventListener('mouseenter', function () { clearInterval(timer); });
      el.addEventListener('mouseleave', function () { timer = setInterval(function () { show(i + 1); }, speed); });
    }
  }

  /* ---------- hero slider ---------- */
  function initHero(el) {
    if (el.getAttribute('data-glx-init')) return;
    el.setAttribute('data-glx-init', '1');
    var track = $('[data-glx-hero-track]', el);
    var slides = $$('[data-glx-hero-slide]', el);
    var dots = $$('[data-glx-hero-dot]', el);
    if (!track || slides.length < 2) return;
    var index = 0;
    var timer;
    function width() {
      return track.clientWidth || 1;
    }
    function setActive(i) {
      index = i;
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * width(), behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / width());
        if (i !== index && i >= 0 && i < slides.length) setActive(i);
      });
    }, { passive: true });
    window.addEventListener('resize', function () {
      track.scrollTo({ left: index * width(), behavior: 'auto' });
    });
    var prev = $('[data-glx-hero-prev]', el);
    var next = $('[data-glx-hero-next]', el);
    if (prev) prev.addEventListener('click', function () { go(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(index + 1); restart(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-glx-hero-dot'), 10)); restart(); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); restart(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); restart(); }
    });
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 6000;
    var auto = el.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      if (!auto || timer || document.hidden) return;
      timer = setInterval(function () { go(index + 1); }, speed);
    }
    function restart() { stop(); start(); }
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);
    el.addEventListener('touchstart', stop, { passive: true });
    el.addEventListener('touchend', function () { setTimeout(start, 4000); }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }

  /* ---------- product page ---------- */
  function initProduct(rootEl) {
    if (rootEl.getAttribute('data-glx-init')) return;
    rootEl.setAttribute('data-glx-init', '1');
    var section = rootEl.closest('.shopify-section') || document;
    var jsonEl = $('[data-glx-product-json]', section);
    if (!jsonEl) return;
    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    var form = $('[data-glx-form]', rootEl);
    var idInput = $('[data-glx-variant-id]', form);
    var qtyInput = $('[data-glx-qty]', form);
    var msg = $('[data-glx-msg]', form);
    var fieldsets = $$('.glx-opt', form);
    var addBtns = $$('[data-glx-add]', section);
    var buyBtns = $$('[data-glx-buy]', section);
    var lastIntent = 'add';

    /* gallery */
    var track = $('[data-glx-track]', rootEl);
    var slides = track ? $$('.glx-gallery__slide', track) : [];
    var thumbs = $$('[data-glx-thumb]', rootEl);
    var counter = $('[data-glx-count]', rootEl);
    var gIndex = 0;
    function gw() {
      return track ? track.clientWidth || 1 : 1;
    }
    function setGallery(i) {
      gIndex = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.scrollIntoView && t.offsetParent) {
          var list = t.closest('.glx-gallery__thumbs');
          if (list) {
            if (list.scrollWidth > list.clientWidth) list.scrollTo({ left: t.offsetLeft - 8, behavior: 'smooth' });
            else if (list.scrollHeight > list.clientHeight) list.scrollTo({ top: t.offsetTop - 8, behavior: 'smooth' });
          }
        }
      });
      if (counter) counter.textContent = i + 1 + '/' + slides.length;
    }
    function gotoSlide(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * gw(), behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      setGallery(i);
    }
    if (track) {
      var graf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(graf);
        graf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / gw());
          if (i !== gIndex && i >= 0 && i < slides.length) setGallery(i);
        });
      }, { passive: true });
      window.addEventListener('resize', function () {
        track.scrollTo({ left: gIndex * gw(), behavior: 'auto' });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); gotoSlide(gIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); gotoSlide(gIndex - 1); }
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { gotoSlide(parseInt(t.getAttribute('data-glx-thumb'), 10)); });
    });
    var gp = $('[data-glx-gprev]', rootEl);
    var gn = $('[data-glx-gnext]', rootEl);
    if (gp) gp.addEventListener('click', function () { gotoSlide(gIndex - 1); });
    if (gn) gn.addEventListener('click', function () { gotoSlide(gIndex + 1); });

    function showMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
          gotoSlide(i);
          return;
        }
      }
    }

    /* variants */
    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = $('.glx-opt__input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      if (!fieldsets.length) return product.variants[0];
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var ok = true;
        for (var k = 0; k < opts.length; k++) {
          if (v.options[k] !== opts[k]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        $$('.glx-opt__input', fs).forEach(function (input) {
          var value = input.value;
          var avail = product.variants.some(function (v) {
            if (!v.available || v.options[i] !== value) return false;
            for (var j = 0; j < opts.length; j++) {
              if (j !== i && v.options[j] !== opts[j]) return false;
            }
            return true;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !avail);
        });
      });
    }
    function setText(sel, value) {
      $$(sel, section).forEach(function (el) {
        el.textContent = value;
      });
    }
    function update(fromUser) {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var l = $('[data-glx-opt-label]', fs);
        if (l) l.textContent = opts[i] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      var addLabel = 'Add to Cart';
      if (!v) {
        addLabel = 'Unavailable';
        addBtns.concat(buyBtns).forEach(function (b) { b.disabled = true; });
        $$('[data-glx-add-label]', section).forEach(function (s) { s.textContent = addLabel; });
        var av0 = $('[data-glx-avail]', form);
        if (av0) av0.innerHTML = '<span class="glx-avail__dot glx-avail__dot--out"></span> This combination is unavailable';
        return;
      }
      idInput.value = v.id;
      setText('[data-glx-price]', v.price);
      $$('[data-glx-compare]', section).forEach(function (el) {
        el.hidden = !v.compare;
        if (v.compare) el.textContent = v.compare;
      });
      $$('[data-glx-pct]', section).forEach(function (el) {
        el.hidden = !v.compare;
        if (v.compare) el.textContent = v.pct + '% OFF';
      });
      var av = $('[data-glx-avail]', form);
      if (av) {
        av.innerHTML = !v.available
          ? '<span class="glx-avail__dot glx-avail__dot--out"></span> Sold out'
          : (v.inv > 0 && v.inv <= 5
            ? '<span class="glx-avail__dot glx-avail__dot--low"></span> Only ' + v.inv + ' left'
            : '<span class="glx-avail__dot"></span> In stock');
      }
      addLabel = v.available ? 'Add to Cart' : 'Sold out';
      addBtns.concat(buyBtns).forEach(function (b) { b.disabled = !v.available; });
      $$('[data-glx-add-label]', section).forEach(function (s) { s.textContent = addLabel; });
      var skuWrap = $('[data-glx-sku-wrap]', section);
      if (skuWrap) {
        skuWrap.hidden = !v.sku;
        var sk = $('[data-glx-sku]', skuWrap);
        if (sk) sk.textContent = v.sku || '';
      }
      if (fromUser) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
        showMedia(v.media);
      }
      document.dispatchEvent(new CustomEvent('glx:variant:change', { detail: { variant: v, product: product } }));
    }
    form.addEventListener('change', function (e) {
      if (e.target.classList.contains('glx-opt__input')) {
        msg.hidden = true;
        update(true);
      }
    });

    /* quantity */
    function clampQty() {
      var n = parseInt(qtyInput.value, 10);
      if (!n || n < 1) n = 1;
      if (n > 999) n = 999;
      qtyInput.value = n;
      return n;
    }
    var minus = $('[data-glx-qty-minus]', form);
    var plus = $('[data-glx-qty-plus]', form);
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, clampQty() - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = clampQty() + 1; });
    qtyInput.addEventListener('change', clampQty);

    /* submit: Add to Cart uses the Shopify cart, Buy Now goes straight to checkout */
    addBtns.forEach(function (b) { b.addEventListener('click', function () { lastIntent = 'add'; }); });
    buyBtns.forEach(function (b) { b.addEventListener('click', function () { lastIntent = 'buy'; }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var buy = e.submitter ? e.submitter.hasAttribute('data-glx-buy') : lastIntent === 'buy';
      var btn = e.submitter || (buy ? buyBtns[0] : addBtns[0]);
      var v = findVariant(selectedOptions());
      if (!v || !v.available) {
        msg.textContent = 'Please choose an available option.';
        msg.hidden = false;
        return;
      }
      msg.hidden = true;
      var qty = clampQty();
      var all = addBtns.concat(buyBtns);
      all.forEach(function (b) { b.classList.add('is-busy'); });
      if (!buy && window.GLXCart && window.GLXCart.opening) window.GLXCart.opening();
      addToCart(v.id, qty)
        .then(function () {
          if (buy) {
            window.location.href = root + 'checkout';
            return null;
          }
          return refreshCartCount().then(function (cart) {
            if (window.GLXCart) window.GLXCart.afterAdd(cart);
            else toast(product.title + ' added to your cart', { href: cartUrl(), label: 'View cart' });
          });
        })
        .catch(function (err) {
          if (!buy && window.GLXCart && window.GLXCart.addFailed) window.GLXCart.addFailed();
          msg.textContent = err.message;
          msg.hidden = false;
          toast(err.message, { error: true });
        })
        .then(function () {
          if (!buy) all.forEach(function (b) { b.classList.remove('is-busy'); });
          else setTimeout(function () { all.forEach(function (b) { b.classList.remove('is-busy'); }); }, 6000);
        });
    });

    update(false);

    /* honour ?variant= in the URL: scroll gallery to that variant's photo */
    try {
      var vid = new URL(window.location.href).searchParams.get('variant');
      if (vid) {
        var match = product.variants.filter(function (x) { return String(x.id) === vid; })[0];
        if (match) showMedia(match.media);
      }
    } catch (e) {}
    setGallery(0);
  }

  /* ---------- related products (Shopify recommendations API) ---------- */
  function initRelated(el) {
    if (el.getAttribute('data-glx-init')) return;
    el.setAttribute('data-glx-init', '1');
    if ($('.glx-grid', el)) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-glx-related]', doc);
        if (fresh && $('.glx-grid', fresh)) {
          el.innerHTML = fresh.innerHTML;
          wlSync();
        } else {
          var sec = el.closest('.glx-related-section');
          if (sec) sec.hidden = true;
        }
      })
      .catch(function () {
        var sec = el.closest('.glx-related-section');
        if (sec) sec.hidden = true;
      });
  }

  /* ---------- init ---------- */
  function init(scope) {
    scope = scope || document;
    $$('[data-glx-search]', scope).forEach(initSearch);
    $$('[data-glx-announce]', scope).forEach(initAnnounce);
    $$('[data-glx-hero]', scope).forEach(initHero);
    $$('[data-glx-product]', scope).forEach(initProduct);
    $$('[data-glx-related]', scope).forEach(initRelated);
    wlSync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCartCount();
  });
  window.GLXTheme = { $: $, $$: $$, esc: esc, root: root, toast: toast, showDrawer: showDrawer, hideDrawer: hideDrawer, init: init, refreshCartCount: refreshCartCount, formatMoney: formatMoney };
})();